module.exports = __webpack_public_path__ + "img/selected4-min.47c0d618.png";